export default __webpack_public_path__ + "static/media/gmx-logo-with-name.59a2af6c.svg";